import { ReactComponent as DepositIcon } from '@basqet-dashboard/common/assets/icons/deposit.svg';
import { ReactComponent as ReceiveIcon } from '@basqet-dashboard/common/assets/icons/receive.svg';
import { ReactComponent as SendIcon } from '@basqet-dashboard/common/assets/icons/send.svg';
import { ReactComponent as WithdrawalIcon } from '@basqet-dashboard/common/assets/icons/withdrawal.svg';
import React from 'react';

const PAYOUT_ACTION_ITEMS = [
  {
    label: 'Send',
    icon: <SendIcon />,
    modal: 'PAYOUT_TRANSFER_MODAL'
  },
  {
    label: 'Receive',
    icon: <ReceiveIcon />,
    path: '/payouts/receive'
  },
  {
    label: 'Deposit',
    icon: <DepositIcon />,
    disabled: true
  },
  {
    label: 'Withdraw',
    icon: <WithdrawalIcon />,
    disabled: true
  }
];

export { PAYOUT_ACTION_ITEMS };
